var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.433 17.0826C15.433 14.0081 17.9254 11.5156 21 11.5156V11.5156C24.0746 11.5156 26.567 14.0081 26.567 17.0826V19.763H15.433V17.0826Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3711 18.938C14.2665 18.938 13.3711 19.8334 13.3711 20.938V29.9277C13.3711 31.0322 14.2665 31.9277 15.3711 31.9277H26.6288C27.7334 31.9277 28.6288 31.0322 28.6288 29.9277V20.938C28.6288 19.8334 27.7334 18.938 26.6288 18.938H15.3711ZM22.6494 23.8864C22.6494 24.4073 22.408 24.8718 22.0309 25.1741V27.1854C22.0309 27.7548 21.5693 28.2164 21 28.2164C20.4306 28.2164 19.969 27.7548 19.969 27.1854V25.1742C19.5919 24.8719 19.3504 24.4073 19.3504 23.8864C19.3504 22.9754 20.0889 22.2369 20.9999 22.2369C21.9109 22.2369 22.6494 22.9754 22.6494 23.8864Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.74f28cc1ef3b65f2211953a12cfde661.svg";
export { ForwardRef as ReactComponent };